<template>
	<b-form
		ref="form"
		@submit.prevent="setCustomerPost"
	>

		<b-card
			no-body
			class="mb-1"
		>

			<b-card-header
				header-tag="header"
				class="p-1"
				role="tab"
			>

				<label><input
						type="radio"
						checked
						name="creating"
						value="false"
						v-model="creating"
						v-b-toggle.accordion-1
					/>
					Find existing</label>

			</b-card-header>

			<b-collapse
				id="accordion-1"
				visible
				accordion="customer-accordion"
				role="tabpanel"
			>
				<b-card-body>

					<b-card-text>

						<b-form-group>
							<vue-typeahead-bootstrap
								class="mb-4"
								v-model="query"
								:data="customers"
								:serializer="item => item.Name"
								@hit="loadCustomer($event)"
								placeholder="Search existing customers"
							/>
						</b-form-group>

					</b-card-text>

				</b-card-body>
			</b-collapse>
		</b-card>

		<b-card
			no-body
			class="mb-1"
		>

			<b-card-header
				header-tag="header"
				class="p-1"
				role="tab"
			>
				<label>
					<input
						type="radio"
						name="creating"
						value="true"
						v-model="creating"
						v-b-toggle.accordion-2
					/>
					Create new</label>

			</b-card-header>

			<b-collapse
				id="accordion-2"
				accordion="customer-accordion"
				role="tabpanel"
			>
				<b-card-body>

					<b-card-text>

						<b-form-group>

							<b-input
								id="name"
								v-model="customer.Name"
								type="text"
								placeholder="New Customer name"
								required
							/>

						</b-form-group>

					</b-card-text>

				</b-card-body>

			</b-collapse>

		</b-card>

		<b-button
			type="submit"
			variant="info"
		>Set Customer</b-button>

	</b-form>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import CustomerService from "@/api-services/customer.service";

export default {
	name: "SetOrCreateCustomer",

	// things we want to use
	components: {
		VueTypeaheadBootstrap
	},

	// things we have inherited from our parent
	props: [],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			query: "",
			creating: false,
			customer: {
				Name: "",
				Clocks: [],
				Contacts: [],
				ServiceContracts: []
			},
			customers: []
		};
	},

	// things we do to data
	methods: {
		setCustomerPost() {
			if (this.creating) {
				// this might have been populated by loading in an existing customer and then swapping.
				delete this.customer.Id;

				CustomerService.create(this.customer)
					.then(response => {
						this.$emit("set", response.data);
					})
					.catch(error => {
						console.log(error.response.data);
					});
			} else {
				this.$emit("set", this.customer);
			}
		},

		loadCustomer(customer) {
			this.customer = customer;
		}
	},

	// data we watch for changes
	watch: {
		// When the query value changes, fetch new results from
		// the API - in practice this action should be debounced
		query(newQuery) {
			CustomerService.search(newQuery).then(res => {
				this.customers = res.data;
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/set-customer.vue